import React from 'react';

export default function MessagingSelected() {
  return (
    <svg className="availabilityIcon availabilityIcon-messagingSelected" width="32" height="32">
      <defs>
        <rect id="a" width="30" height="30" rx="15" className="availabilityIcon-messagingSelected-rect" />
      </defs>
      <g fill="#009B00" fillRule="evenodd">
        <g transform="translate(1 1)">
          <rect
            stroke="#009b00"
            x=".5"
            y=".5"
            width="29"
            height="29"
            rx="14.5"
            className="availabilityIcon-messagingSelected-rect"
          />
        </g>
        <path
          className="availabilityIcon-messagingSelected-path"
          d="M17.082 21.5l-3.707 3.707V21.5h-.25C9.755 21.5 7 18.745 7 15.375S9.755 9.25 13.125 9.25h6c3.37 0 6.125 2.755 6.125 6.125S22.495 21.5 19.125 21.5h-2.043z"
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/page_layout/agent_status/icons/messaging_selected.jsx